// components/header/AmsterHeader.tsx
'use client';
import React, { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import TopBar from './TopBar';
import BottomNav from './BottomNav';

const AmsterHeader = () => {
  const [hideNav, setHideNav] = useState(false);
  const pathname = usePathname();
  const [navPathname, setNavPathname] = useState(pathname);
  const lastScrollYRef = React.useRef(0);
  const scrollEnabledRef = React.useRef(false);
  const SCROLL_THRESHOLD = 30;

  // Reset on navigation
  if (navPathname !== pathname) {
    setNavPathname(pathname);
    setHideNav(false);
  }

  useEffect(() => {
    // Disable scroll handling during navigation
    scrollEnabledRef.current = false;

    // Re-enable after page settles
    const timer = setTimeout(() => {
      lastScrollYRef.current = window.scrollY;
      scrollEnabledRef.current = true;
    }, 300);

    return () => clearTimeout(timer);
  }, [pathname]);

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      // Skip if scroll handling is disabled
      if (!scrollEnabledRef.current || ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        const lastScrollY = lastScrollYRef.current;

        if (currentScrollY > lastScrollY + SCROLL_THRESHOLD && currentScrollY > 100) {
          setHideNav(true);
          lastScrollYRef.current = currentScrollY;
        } else if (currentScrollY < lastScrollY - SCROLL_THRESHOLD) {
          setHideNav(false);
          lastScrollYRef.current = currentScrollY;
        } else if (currentScrollY < 50) {
          setHideNav(false);
          lastScrollYRef.current = currentScrollY;
        }

        ticking = false;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* TopBar가 헤더 최상단에 위치 */}
      <TopBar />
      {/* BottomNav - no overflow:hidden wrapper to allow fixed dropdowns to render properly */}
      <div
        className="transition-all duration-300 ease-out bg-[#374151]"
        style={{
          height: hideNav ? '0px' : '30px',
          opacity: hideNav ? 0 : 1,
          pointerEvents: hideNav ? 'none' : 'auto',
        }}
      >
        <BottomNav />
      </div>
    </header>
  );
};

export default AmsterHeader;